import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { UserRoles } from 'src/app/enums/userRoles.enum';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { UserService } from 'src/app/services/user.service';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-sidebar3',
  templateUrl: './sidebar3.component.html',
  styleUrls: ['./sidebar3.component.css'],
  animations: [
    trigger('slideInOut', [
      state('void', style({
        transform: 'translateX(-100%)'
      })),
      state('*', style({
        transform: 'translateX(0%)'
      })),
      transition('void => *', [
        animate('0.5s ease-in-out', style({
          transform: 'translateX(0%)'
        }))
      ]),
      transition('* => void', [
        animate('0.5s ease-in-out', style({
          transform: 'translateX(-100%)'
        }))
      ])
    ])
  ]
})
export class Sidebar3Component {

  @Input() isOpen = false;

  @Input() activeOption: any;

  @Output() sideBarCollapseEmitter = new EventEmitter();

  isEmployeeExpanded: boolean = false;

  isExecutiveExpanded: boolean = false;

  isKmsExpanded: boolean = false;

  isPortalExpanded: boolean = false;

  isGovernanceExpanded: boolean = false;

  isOthersExpanded: boolean = false;

  childrensOfMegaMenu = {
    isEmployeeExpanded: [
      '/Home/Dashboard',
      'Home/Dashboard/Employee Impersonation',
      '/Home/employee-career/employee-Career-path',
      '/Home/employee-career/employee-Career-program',
      '/Home/Skill Repository',
      '/Home/employee-career/program-catalogue',
      'Home/employee-career/employee-Career-path/program-catalogue',
      '/Home/employee-career/add-programs',
      '/Home/employee-career/employee-Career-request/my-requests',
      '/Home/employee-career/employee-Career-request/team-requests',
    ],
    isExecutiveExpanded: ['/Home/Customer360'],
    isKmsExpanded: [
      '/Home/KMSPortal',
      '/Home/KMS Portal',
      'Home/KMSPortal/Project Content',
      'Home/KMSPortal/Pending Approvals',
      '/users/userlist',
    ],
    isPortalExpanded: ['/Home/CMF Portal'],
    isGovernanceExpanded: ['/Home/Compliance', '/Home/Timesheet Management'],
    isOthersExpanded: [
      '/Home/Proposal Repository',
      '/Home/Artifactory Repository',
      '/Home/Artifactory',
      '/Home/ProjectTechStack',
      '/Home/Proof Of Concepts',
      '/Home/Audit',
      'Home/MasterQuestion',
    ],
  };

  public hideMenu = {
    dashboard: false,
    competency: false,
    home: false,
    employee: false,
    executive: false,
    techstack: false,
    salaryRangeCalcualtor: false,
    skillRepository: false,
    uploadData: false,
    employeData: false,
    templates: false,
    proposals: false,
    mockups: false,
    employeemenu: false,
    sales: false,
    salesdashboard: false,
    projectcontent: false,
    pendingapprovals: false,
    users: false,
    career: false,
    other: false,
    dmdPortal: false,
    ppmPortal: false,
    compliance: false,
    portal: false,
    audits: false,
    timeSheet: false,
    pstimesheet: false,
    poc:true,
    employeeWithoutCompetency: false,
  };

  showemployeeimpersonation: boolean = false;

  isEmpCareerManager: boolean = false;

  accessForAddPrograms: boolean = false;

  timesheetview: boolean = false;

  accessForKMS: boolean = false;

  allSections: string[] = [
    'isEmployeeExpanded',
    'isExecutiveExpanded',
    'isKmsExpanded',
    'isPortalExpanded',
    'isGovernanceExpanded',
    'isOthersExpanded',
    'isAuditsExpanded'
  ];

  empCareerUserDetailsSubcription: any;

  role: any;

  public loading = false;

  listOFSectionsPresent = [
    {
      name: 'My Dashboard',
      navigateUrl: 'Home/Dashboard',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Employee Impersonation',
      navigateUrl: 'Home/Dashboard/Employee Impersonation',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'showemployeeimpersonation'
    },
    {
      name: 'Employee Skill Repository',
      navigateUrl: 'Home/Skill Repository',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Employee Competency Assignment',
      navigateUrl: 'Home/Missing-mandatory-fields',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'employeeWithoutCompetency'
    },
    {
      name: 'Career Path',
      navigateUrl: 'Home/employee-career/employee-Career-path',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Career Program',
      navigateUrl: 'Home/employee-career/employee-Career-program',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Program Catalogue',
      navigateUrl: 'Home/employee-career/program-catalogue',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Add Programs',
      navigateUrl: 'Home/employee-career/add-programs',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'My Requests',
      navigateUrl: '/Home/employee-career/employee-Career-request/my-requests',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Team Requests',
      navigateUrl: 'Home/employee-career/employee-Career-request/team-requests',
      isAccessible: false,
      moduleName: 'Employee',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Executive Dashboard - 2023',
      navigateUrl: 'https://app.powerbi.com/reportEmbed?reportId=76e04c44-98ba-4282-a009-a71b65409b8b&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Executive Dashboard - 2024',
      navigateUrl: 'https://app.powerbi.com/groups/me/reports/aecdd6f6-f055-4ef1-8f93-d251ffba5d87/ReportSectionb4855d102fdd1dfea32e?experience=power-bi',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Executive Dashboard - 2023 & 2024',
      navigateUrl: 'https://app.powerbi.com/groups/me/reports/f48ee236-24bd-497d-ae1c-e23d5487a92f/ReportSection9dbc46faa1dc574d04e2?experience=power-bi',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'RMG',
      navigateUrl: 'https://app.powerbi.com/reportEmbed?reportId=b956e1bb-20f1-4f52-a459-1539674a0d68&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Sales',
      navigateUrl: 'https://app.powerbi.com/reportEmbed?reportId=b8a3449f-7d47-4b60-9c64-ec0a863987c5&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Pre-sales',
      navigateUrl: 'https://app.powerbi.com/reportEmbed?reportId=98047a43-c119-4370-b99e-2400653a462e&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Customer 360 Portal',
      navigateUrl: '/Home/Customer360',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'GsdReview',
      navigateUrl: 'https://app.powerbi.com/reportEmbed?reportId=cce16eca-a81e-4a7f-9162-996823a113fc&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Global Demand Dashboard',
      navigateUrl: 'https://app.powerbi.com/groups/me/reports/287abbd2-6124-4746-b8d6-ae99fa5bf21e/ReportSectiondb054d34dd265e40dd85?experience=power-bi',
      isAccessible: false,
      moduleName: 'Executive',
      accesibleKey: 'skillRepository'
    },
    {
      name: 'Dashboard',
      navigateUrl: 'Home/KMSPortal',
      isAccessible: false,
      moduleName: 'KMS',
      accesibleKey: '!salesdashboard'
    },
    {
      name: 'Project Content',
      navigateUrl: 'Home/KMSPortal/Project Content',
      isAccessible: false,
      moduleName: 'KMS',
      accesibleKey: '!projectcontent'
    },
    {
      name: 'Pending Approvals',
      navigateUrl: 'Home/KMSPortal/Pending Approvals',
      isAccessible: false,
      moduleName: 'KMS',
      accesibleKey: '!pendingapprovals'
    },
    {
      name: 'Users',
      navigateUrl: '/users/userlist',
      isAccessible: false,
      moduleName: 'KMS',
      accesibleKey: '!users'
    },
    {
      name: 'CMF Portal',
      navigateUrl: '/Home/CMF Portal',
      isAccessible: false,
      moduleName: 'Portal',
      accesibleKey: 'competency'
    },
    {
      name: 'DMD Portal',
      navigateUrl: 'https://dmd.innovasolutions.com',
      isAccessible: false,
      moduleName: 'Portal',
      accesibleKey: 'dmdPortal'
    },
    {
      name: 'PPM Portal',
      navigateUrl: 'https://epas.innovasolutions.com/',
      isAccessible: false,
      moduleName: 'Portal',
      accesibleKey: 'ppmPortal'
    },
    {
      name: 'Compliance',
      navigateUrl: '/Home/Compliance',
      isAccessible: false,
      moduleName: 'Governance',
      accesibleKey: 'compliance'
    },
    {
      name: 'Timesheet Management',
      navigateUrl: '/Home/Timesheet Management',
      isAccessible: false,
      moduleName: 'Governance',
      accesibleKey: 'timesheetview'
    },
    {
      name: 'Proposal Repository',
      navigateUrl: '/Home/Proposal Repository',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'proposals'
    },
    {
      name: 'Artifactory Repository',
      navigateUrl: '/Home/Artifactory Repository',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'templates'
    },
    {
      name: 'Salary Range Calculator',
      navigateUrl: 'salaryRangeNavigate',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'salaryRangeCalcualtor'
    },
    {
      name: 'Project Tech Stack',
      navigateUrl: '/Home/ProjectTechStack',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'techstack'
    },
    {
      name: 'Proof of Concepts',
      navigateUrl: '/Home/Proof Of Concepts',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'poc'
    },
    {
      name: 'Audits',
      navigateUrl: '/Home/Audit',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'dashboard'
    },
    {
      name: 'Master Questions',
      navigateUrl: 'Home/MasterQuestion',
      isAccessible: false,
      moduleName: 'Others',
      accesibleKey: 'dashboard'
    },
  ];

  filteredSections = [];

  searchText = '';

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private auth: AuthServiceService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.role = this.auth.getRole();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.expandActiveParent();
    });
    this.callEmpCareerUserDetails();
    this.configureMenuBasedOnRoles();
  }

  isActiveProgramCatalogueLink() {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/Home/employee-career/employee-Career-path/program-catalogue') ||
      currentUrl.startsWith('/Home/employee-career/program-catalogue');
  }

  isActiveArtifactoryLink() {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/Home/Artifactory Repository') || currentUrl.startsWith('/Home/Artifactory');
  }

  isActiveKMSLink() {
    const currentUrl = this.router.url;
    return (
      (currentUrl.startsWith('/Home/KMSPortal') || currentUrl.startsWith('/Home/KMS%20Portal')) &&
      ![
        '/Home/KMSPortal/Project Content',
        '/Home/KMSPortal/Project%20Content',
        '/Home/KMSPortal/Pending Approvals',
        '/Home/KMSPortal/Pending%20Approvals',
      ].includes(currentUrl)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.expandActiveParent();
      this.cdr.detectChanges();
    }

    if (changes['isOpen'] && changes['isOpen'].currentValue === false) {
      this.searchText = '';
      this.filteredSections = [];
    }
  }

  ngAfterViewInit(): void {
    if (this.isOpen) {
      this.expandActiveParent();
      this.cdr.detectChanges();
    }
  }

  toggleSection(section: string): void {
    this.allSections.forEach((sec) => {
      if (sec === section) {
        this[sec] = !this[sec]; // Toggle the clicked section
      } else {
        this[sec] = false; // Collapse all other sections
      }
    });
  }

  callEmpCareerUserDetails() {
    this.empCareerUserDetailsSubcription = this.userService.empCareerUserDetails.subscribe(data => {
      let employeeDetails;
      if (data) {
        if (typeof data === 'string') {
          employeeDetails = JSON.parse(data);
        } else if (typeof data === 'object') {
          employeeDetails = data;
        }
        this.isEmpCareerManager = employeeDetails?.isManager;
        console.log();
        
        if(this.isEmpCareerManager)
        {
        this.showemployeeimpersonation=true;
        }
        if (employeeDetails.gradeId == 1 && employeeDetails.role == "Intern") {   
          this.hideMenu.poc = false;
        }
        if (
          this.role &&
          !this.role.includes(GsdRoles.PMORole) &&
          employeeDetails.gradeId != 1 &&
          employeeDetails.role != "Intern"
        ) {   
          this.hideMenu.timeSheet = true;
          this.timesheetview = true;
        }
      }
    })
  }

  expandActiveParent() {
    const currentUrl = this.router.url.split('%20').join(' ');
    const currentOption = Object.keys(this.childrensOfMegaMenu).find(key =>
      this.childrensOfMegaMenu[key].some(path => currentUrl.includes(path))
    );
    if (currentOption) {
      this.allSections.forEach((section) => {
        if (section === currentOption) {
          this[section] = true;
        } else {
          this[section] = false;
        }
      });
    } else {
      this.isEmployeeExpanded = true;
    }
  }

  configureMenuBasedOnRoles() {
    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin) ||
      this.role.includes(UserRoles.ContentManager) ||
      this.role.includes(UserRoles.Viewer)
    ) {
      this.accessForKMS = true;
    }

    if (this.role.includes(GsdRoles.Admin)) {
      this.setAdminRolesAccess();
    }

    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.setSuperAdminRolesAccess();
    }
    
    if (this.role.includes(GsdRoles.SkillUser)) {
      this.setUserRolesAccess();
    }

    if (this.role.includes(GsdRoles.CompetencyLeader)) {
      this.setCompetencyLeaderRolesAccess();
    }

    if (this.role.includes(GsdRoles.SubCompetencyLeader)) {
      this.setSubCompetencyLeaderRolesAccess();
    }

    if (this.role.includes(GsdRoles.Leadership)) {
      this.setLeadershipRolesAccess();
    }

    if (this.role.includes(UserRoles.Viewer)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = true;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
    }
  
    if (this.role.includes(UserRoles.ContentManager)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
    }

    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin)
    ) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = false;
      this.hideMenu.users = false;
    }

    this.updateSearchDetails();
  }

  updateSearchDetails() {
    this.listOFSectionsPresent.forEach((item) => {
      if (item.accesibleKey.startsWith('!')) {
        item.isAccessible = !this.hideMenu[item.accesibleKey.slice(1)]
      } else if (this.hasOwnProperty(item.accesibleKey)) {
        item.isAccessible = this[item.accesibleKey];
      } else {
        item.isAccessible = this.hideMenu[item.accesibleKey];
      }
    })
  }

  setLeadershipRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = false;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = true;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = true;
    this.hideMenu.proposals = true;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setSubCompetencyLeaderRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.proposals = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setCompetencyLeaderRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.proposals = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setUserRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = false;
    this.hideMenu.skillRepository = false;
    this.hideMenu.employeeWithoutCompetency = false;
    this.hideMenu.templates = false;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.employeData = false;
    this.hideMenu.proposals = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.home = true;
    this.hideMenu.career = true;
    this.hideMenu.employee = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = false;
    this.hideMenu.compliance = false;
    this.hideMenu.poc = true;
  }

  setSuperAdminRolesAccess() {
    this.accessForAddPrograms = true;
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = true;
    this.hideMenu.portal = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.hideMenu.employeData = true;
    this.hideMenu.proposals = true;
    this.hideMenu.mockups = true;
    this.hideMenu.employeemenu = true;
    this.hideMenu.sales = true;
    this.hideMenu.salesdashboard = false;
    this.hideMenu.projectcontent = false;
    this.hideMenu.pendingapprovals = false;
    this.hideMenu.users = false;
    this.hideMenu.career = true;
    this.hideMenu.executive = true;
    this.hideMenu.techstack = true;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.hideMenu.other = true;
    this.hideMenu.compliance = true;
    this.hideMenu.audits = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setAdminRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = true;
    this.hideMenu.portal = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.hideMenu.employeData = true;
    this.hideMenu.proposals = true;
    this.hideMenu.mockups = true;
    this.hideMenu.employeemenu = true;
    this.hideMenu.sales = true;
    this.hideMenu.salesdashboard = false;
    this.hideMenu.projectcontent = false;
    this.hideMenu.pendingapprovals = false;
    this.hideMenu.users = false;
    this.hideMenu.career = true;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = true;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = true;
    this.showemployeeimpersonation = true;
  }

  navigateTo(path) {
    this.loading = true;
    this.router.navigate([path])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  isEmpCareerActivated(): boolean {
    const empCarrerUrls = [
      '/Home/employee-career/employee-Career-program',
      '/Home/employee-career/employee-Career-request',
      '/Home/employee-career/employee-Career-request/my-requests',
      '/Home/employee-career/employee-Career-request/team-requests',
      '/Home/employee-career/program-catalogue',
      '/Home/employee-career/add-programs'
    ]
    return empCarrerUrls.includes(this.router.url);
  }

  programCatalogueNavigate(): void {
    this.loading = true;
    this.isEmpCareerActivated() ? this.router.navigate(['Home/employee-career/employee-Career-path'])
      .then(() => {
        this.router.navigateByUrl(
          '/Home/employee-career/employee-Career-path/program-catalogue',
          { state: { selectedGrade: '' } }
        );
        this.loading = false
      })
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      }) : this.router.navigate(['Home/employee-career/'])
        .then(() => {
          this.router.navigateByUrl(
            '/Home/employee-career/program-catalogue', 
            { state: { selectedGrade: '' } }
          );
          this.loading = false
        })
        .catch(err => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '280px',
            data: { message: 'Cannot Open', class: 'text-danger' }
          });
        });
    this.dismissSidebar();
  }

  salaryRangeNavigate(): void {
    let salaryCalculatorUrl = 'http://172.16.0.45:8074?id_token=' + localStorage.getItem('MsSSOToken');
    window.open(salaryCalculatorUrl, "_blank");
    this.dismissSidebar();
  }

  dismissSidebar() {
    this.isOpen = false;
    const activeOption = this.allSections.find(section => this[section]);
    this.searchText = '';
    this.filteredSections = [];
    this.sideBarCollapseEmitter.emit({
      isSideBarOpen: this.isOpen,
    });
  }

  ngOnDestroy(): void {
    this.empCareerUserDetailsSubcription?.unsubscribe();
  }

  showSuggestions(autocompleteTrigger: MatAutocompleteTrigger) {
    autocompleteTrigger.openPanel();
    if (this.searchText.trim()) {
      this.filteredSections = this.listOFSectionsPresent.filter((item) =>
        (item.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
          item.moduleName.toLowerCase().includes(this.searchText.toLowerCase())) && item.isAccessible
      );
      if (!this.filteredSections.length) {
        this.filteredSections = [{notFoundMsg: 'No matching module or feature found. Please try again.'}];
      }
    } else {
      this.filteredSections = [];
    }
  }

  navigateFromSearch(screenObj) {
    if (!screenObj || !screenObj.navigateUrl) {
      return;
    }
    const navigateByUrl = screenObj.navigateUrl;
    if (screenObj.name === 'Salary Range Calculator') {
      this.salaryRangeNavigate();
      return;
    }
    this.searchText = '';
    this.filteredSections = [];
    if (navigateByUrl.startsWith('https')) {
      window.open(navigateByUrl);
      this.dismissSidebar();
    } else {
      this.navigateTo(navigateByUrl);
    }
  }

  isNotFountMsg() {
    return this.filteredSections.length === 1 && this.filteredSections[0].notFoundMsg;
  }

  handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.searchText === '') {
      this.filteredSections = [];
      this.cdr.detectChanges();
    }
  }
}
